/**
 *
 * Organizations/Index
 *
 */

import React, { memo } from 'react'

import PropTypes from 'prop-types'
import styled from '@emotion/styled'
import { gql, useMutation } from '@apollo/client'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import useQuery from 'components/UseQuery'

import Organization from 'components/Organizations/Show'
import { COLORS } from 'global-styles'
import { listToText } from '@joeyparis/utils'

export const BlockedBannerContainer = styled.div`
	position: absolute;
	top: 20%;
	left: 0;
	width: 100%;
	display: flex;
	align-items: center;
	justify-content: center;
	z-index: 999;

	div {
		text-align: center;
		color: ${COLORS.black};
		background-color: ${COLORS.grey_c};
		padding: 10px 20px;
		margin: 0 20px;
		font-size: 1.1rem;
		border: 2px solid ${COLORS.black};
	}

	.org_name {
		white-space: nowrap;
	}
`

export const BlockedMessageContainer = styled.div`
	width: 100%;
	text-align: center;
	color: ${COLORS.black};
	background-color: ${COLORS.grey_c};
	padding: 5px;
	font-size: 0.9rem;
	border: 1px solid ${COLORS.black};
	border-radius: 3px;
	margin-bottom: 10px;

	.org_name {
		white-space: nowrap;
		font-style: italic;
	}
`

export const GET_ORGANIZATIONS = gql`
	query getOrganizations($object_type: String, $object_id: ID) {
		organizations(object_type: $object_type, object_id: $object_id) {
			id
			name
			image_url
			has_object
		}
	}
`

const CREATE_ORGANIZATION = gql`
	mutation createOrganization {
		createOrganization(input: {}) {
			organization {
				id
			}
		}
	}
`
const GET_USERS = gql`
	{
		users {
			id
			full_name
			email
			company_name
			profile_image
		}
	}
`
export function BlockedBanner({ category, organization_name }) {
	return (
		<BlockedBannerContainer>
			<div>
				<span>
					Your <b>{category}</b> are Standardized at the Organization level.
				</span>{' '}
				{organization_name && <span className="org_name">({organization_name})</span>}
			</div>
		</BlockedBannerContainer>
	)
}

export function BlockedMessage({ category = '', override_message = null, organization_name, className }) {
	const category_text = Array.isArray(category) ? listToText(category) : category

	return (
		<BlockedMessageContainer className={className}>
			{override_message ? (
				<span>{override_message}</span>
			) : (
				<span>
					Your <b>{category_text}</b> are Standardized at the Organization level.
				</span>
			)}{' '}
			{organization_name && <span className="org_name">({organization_name})</span>}
		</BlockedMessageContainer>
	)
}

function Index() {
	const {
		data: { organizations },
		refetch,
	} = useQuery(GET_ORGANIZATIONS, { default_data: { organizations: [] } })

	const {
		data: { users },
	} = useQuery(GET_USERS, {
		default_data: { users: [] },
		fetchPolicy: 'cache-and-network', // Hoping this will query in the background
	})

	const [createOrganization] = useMutation(CREATE_ORGANIZATION, { onCompleted: () => refetch() })

	return (
		<div className="container h-100">
			<div className="row">
				{organizations.map((organization) => (
					<div key={organization.id} className="col-3">
						<Organization {...organization} users={users} />
					</div>
				))}
				<div className="col-1">
					<div className="card">
						<div className="card-body text-center">
							<FontAwesomeIcon icon="plus" onClick={() => createOrganization()} />
						</div>
					</div>
				</div>
			</div>
		</div>
	)
}

Index.propTypes = {}

BlockedBanner.propTypes = {
	category: PropTypes.string,
	organization_name: PropTypes.string,
}

export default memo(Index)
